import { executeStepFunction } from "../../utils/command/stepDataLoader";

export class PromptResolver {
  async resolvePrompt(step, options = {}) {
    if (!step) return null;

    const {
      skipIntro = false,
      sessionData = {},
      callbacks = {},
      loadedData = null,
      attributes = {},
    } = options;
    let fullPrompt = "";

    try {
      // Add step intro if present and not skipped
      if (!skipIntro && step.intro) {
        console.log("🔍 Resolving step intro...");
        const dynamicIntro = await executeStepFunction(
          step.intro,
          null, // intro doesn't take input
          sessionData,
          loadedData,
          callbacks,
          attributes
        );
        if (dynamicIntro) {
          fullPrompt += dynamicIntro;
          fullPrompt += "\n";
        }
      }

      // Check if step has no prompt (auto-advance step)
      if (!step.prompt) {
        // For steps without prompts, return only the intro (if any)
        return fullPrompt || null;
      }

      // Add the main prompt
      console.log("🔍 Resolving step prompt...");
      const dynamicPrompt = await executeStepFunction(
        step.prompt,
        null, // prompt doesn't take input
        sessionData,
        loadedData,
        callbacks,
        attributes
      );
      if (dynamicPrompt) {
        fullPrompt += dynamicPrompt;
      }

      console.log("✅ Prompt resolved:", fullPrompt);
      return fullPrompt;
    } catch (error) {
      console.error("❌ Error resolving prompt:", error);
      return null;
    }
  }

  async buildIntroMessage(command, sessionData = {}, callbacks = {}) {
    let introMessage = "";
    if (command.intro) {
      const dynamicIntro = await executeStepFunction(
        command.intro,
        null, // intro doesn't take input
        sessionData,
        null, // no loaded data at command level
        callbacks
      );
      if (dynamicIntro) {
        introMessage += dynamicIntro;
        introMessage += "\n";
      }
    }
    return introMessage;
  }

  combinePrompts(intro, prompt) {
    return intro ? intro + prompt : prompt;
  }
}
